import { useEffect, useRef, useState } from 'react';

import { postProduct } from '../actions';
import { setMetaTags } from '../store/actions';
import { useStateContext } from '../store/stateContext';
import { Product } from '../types';

const extractMetaTags = () => {
    const metaTags = document.querySelectorAll('meta[property^="og:"]');
    const metaData: { [key: string]: string } = {};

    metaTags.forEach((tag) => {
        const property = tag.getAttribute('property');
        const content = tag.getAttribute('content');
        if (property && content) {
            metaData[property] = content;
        }
    });

    return metaData;
};

const postMetaData = async (metaData: { [key: string]: string }) => {
    const scriptTag = document.getElementById('widget_loader');
    const widgetId = scriptTag?.getAttribute('data-widget-id');
    const product: Partial<Product> = {
        product_id: metaData['og:url'],
        name: metaData['og:title'],
        image: metaData['og:image'],
        category: metaData['og:category'],
        url: metaData['og:url'],
        widget_id: widgetId || '',
        extra_info: metaData,
    };
    try {
        const response: unknown = await postProduct(product);
        console.log({ response });
    } catch (error) {
        console.error('Failed to create product:', error);
        throw error;
    }
};

const useMetaTags = () => {
    const { state, dispatch } = useStateContext();
    const [isReady, setIsReady] = useState(false);
    const [metaData, setMetaData] = useState<{ [key: string]: string }>({});
    const hasMountedRef = useRef(false);

    useEffect(() => {
        const saveProduct = async () => {
            const metaData = extractMetaTags();
            setMetaData(metaData);
            dispatch(setMetaTags(metaData));
            console.log('Extracted Meta Data:', state, metaData);
            await postMetaData(metaData);
            setIsReady(true);
        };

        if (!hasMountedRef.current) {
            saveProduct();
            hasMountedRef.current = true;
        }
    }, []);

    return { isReady, metaData };
};

export default useMetaTags;
